export default __webpack_public_path__ + "static/media/tribe_personajes_king.8c063a18.png";